import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { useFormikContext } from "formik";

import { ConfirmUpdateWeightProps } from "../../../interface/dialog/ConfirmUpdateWeightProps";
import { TruckScaleFormValues } from "../../../interface/formik/ScaleFormValues";
import Button from "../Button";
import { useDialogStyles } from "./styles";

const ConfirmUpdateWeightDialog = ({
  open,
  onClose,
}: ConfirmUpdateWeightProps) => {
  const classes = useDialogStyles();

  const { handleSubmit } = useFormikContext<TruckScaleFormValues>();

  return (
    <Dialog open={open} onClose={() => onClose()} fullWidth maxWidth="xs">
      <DialogTitle className={classes.dialogTitle}>
        {"Manually Set Scale Weight"}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <DialogContentText>
          Are you sure you want to manually update the scale weight?
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <div className={classes.actionButton}>
          <Button
            label="Cancel"
            type="button"
            onClick={() => onClose()}
            color="default"
            variant="contained"
          />
        </div>
        <div className={classes.actionButton}>
          <Button
            label="Update Weight"
            type="button"
            onClick={() => {
              handleSubmit();
              onClose();
            }}
            autoFocus
            color="primary"
            variant="contained"
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmUpdateWeightDialog;
